import React, { useState, useEffect } from 'react';
// @material-ui/core components
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { Link } from 'react-router-dom';
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
// core components
import { connect } from 'react-redux';
import { getAllVendors as getVendorList } from '../../store/actions/admin/Admin';
import {
  getAllSubCategory as getCategoryList,
  getSubCategoryDetails,
  deleteSubCategories
} from '../../store/actions/vendor/Vendor';
import CardHeader from '../../components/Card/CardHeader.js';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

const SubCategoriesTable = (props) => {
  const classes = useStyles();
  const { className } = props;
  const [modal, setModal] = useState(false);
  const [theSuperCategoryId, setSuperCategoryId] = useState('');
  const [theCategoryId, setCategoryId] = useState('');
  const [modal2, setModal2] = useState(false);

  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);

  const [itemCategoryId, setItemCategoryId] = useState(0);
  const [itemSuperCategoryId, setItemSuperCategoryId] = useState(0);
  const [itemSubCategoryId, setItemSubCategoryId] = useState(0);

  useEffect(() => {
    const { categoryId, superCategoryId } = props.match.params;
    setSuperCategoryId(superCategoryId);
    setCategoryId(categoryId);
    props.getCategoryList(categoryId);
  }, []);

  const fetchDetails = async (subCategoryId) => {
    props.getSubCategoryDetails(subCategoryId);
  };

  const handleDelete = (superCategoryId, categoryId, subCategoryId) => {
    props
      .deleteSubCategories(superCategoryId, categoryId, subCategoryId)
      .then((data) => {
        if (data) {
          props.getCategoryList(props.match.params.categoryId);
          props.getVendorList();
          setSuperCategoryId(props.match.params.superCategoryId);
          setCategoryId(props.match.params.categoryId);
        }
      });
  };
  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>
          All Sub-Categories - Add, Update, Delete
        </h4>
        <p className={classes.cardCategoryWhite}>
          When choosing icons, PNG images would be better over JPG or imap
        </p>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Added by</th>
            <th>Name</th>
            <th>Icon</th>
            <th>Update</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {props.subCategories.length !== 0 ? (
            props.subCategories.map((item, i) => (
              <tr key={item.id}>
                <th scope="row">{i + 1}</th>
                {props.allVendors.filter(
                  (categorieFilter) => categorieFilter.id === item.addedBy
                ).length > 0 ? (
                  props.allVendors
                    .filter(
                      (categorieFilter) => categorieFilter.id === item.addedBy
                    )
                    .map((type) => <td key={type.id}>{type.name}</td>)
                ) : (
                  <td> A {item.userRoleOfAddedBy} </td>
                )}
                <td>{item.name}</td>
                <td>
                  <img
                    src={item.icon}
                    alt={item.name}
                    style={{ height: '100px' }}
                  />
                </td>
                <td>
                  <Link
                    style={{ color: '#000' }}
                    to={
                      '/vendor/sub-category-edit/' +
                      item.superCategoryId +
                      '/' +
                      item.categoryId +
                      '/' +
                      item.id
                    }
                  >
                    <EditIcon
                      onClick={function (event) {
                        toggle();
                        fetchDetails(item.id);
                      }}
                    />{' '}
                  </Link>
                </td>
                <td>
                  <DeleteIcon
                    onClick={function (event) {
                      toggle();
                      setItemSuperCategoryId(item.superCategoryId);
                      setItemCategoryId(item.categoryId);
                      setItemSubCategoryId(item.id);
                    }}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td></td>
              <td>No data yet</td>
              <td></td>
              <td>No data yet</td>
              <td></td>
              <td>No data yet</td>
            </tr>
          )}
        </tbody>
      </Table>

      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>Delete</ModalHeader>
        <ModalBody>Do you really want to delete this SubCategory??</ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(
                itemSuperCategoryId,
                itemCategoryId,
                itemSubCategoryId
              );
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modal2} toggle={toggle2} className={className}>
        <ModalHeader toggle={toggle2}>Modify a SubCategory</ModalHeader>
        <ModalBody></ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(
                itemSuperCategoryId,
                itemCategoryId,
                itemSubCategoryId
              );
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle2}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Link
        to={
          '/vendor/add-sub-category/' + theSuperCategoryId + '/' + theCategoryId
        }
      >
        <a
          classsName="float-button"
          style={{
            position: 'fixed',
            width: '60px',
            height: '60px',
            bottom: '80px',
            right: '20px',
            backgroundColor: '#A742B9',
            color: '#FFF',
            borderRadius: '50px',
            textAlign: 'center',
            boxShadow: '2px 2px 3px #A742B9'
          }}
          href="//#endregion"
        >
          <i
            className="fa fa-plus my-float-button"
            style={{ marginTop: '22px', fontWeight: 600 }}
          >
            {' '}
            Add
          </i>
        </a>{' '}
      </Link>
    </>
  );
};

const mapStateWithProps = (state) => ({
  allVendors: state.admin.allVendors,
  subCategories: state.vendor.subCategories,
  subCategoryDetails: state.vendor.subCategoryDetails
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getVendorList: () => dispatch(getVendorList()),
    getCategoryList: (categoryId) => dispatch(getCategoryList(categoryId)),
    getSubCategoryDetails: (subCategoryId) =>
      dispatch(getSubCategoryDetails(subCategoryId)),
    deleteSubCategories: (superCategoryId, categoryId, subCategoryId) =>
      dispatch(deleteSubCategories(superCategoryId, categoryId, subCategoryId))
  };
};

export default connect(
  mapStateWithProps,
  mapDispatchWithProps
)(SubCategoriesTable);
